import type { FaireProductEntity } from "../../entity_types/product";

export const p_u5xgx3z6nd: FaireProductEntity = {
  token: "p_u5xgx3z6nd",
  type: "product",
  name: "Lick Mat | Stress-Free Grooming Tool - Silicone",
  brandToken: "b_bf7zwxbsts",
  brandName: "Dandylion",
  imageUrl: "https://cdn.faire.com/fastly/f848f56766b3b613a746f8478d623095a51bee59a03882c63947af02b2d60fed.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/0d67cde67b096e6253aa2899a8ee056e17cd32704953cfced68f1c6c05a08780.jpeg"
  ],
  priceDollars: 9,
  description: "Transform grooming into a stress-free, enjoyable experience with Dandylion’s Lick Mat. Specially designed to keep your dog calm and engaged, our lick mat is the ultimate grooming tool for dog parents who want to create a positive association to paw care, bath time and general grooming.\n\nHow to use\n\n• Spread dog-friendly treats like peanut butter, yogurt, or cottage cheese evenly over the surface of the lick mat.\n• Introduce the lick mat to your dog by placing it on a smooth surface such as the floor, tiled bathroom walls, or holding it in your hand to let them explore and start licking.\n• Clean the lick mat thoroughly after each use. Hand wash it in warm, soapy water, or place it in the dishwasher for convenient cleaning.\n\n100% Food-Grade Silicone | Non-Toxic | Dishwasher Safe\n\nMade in China",
  tags: [],
  msrpDollars: 18,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-13T16:24:40.704Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
